<template>
  <section class="box">
    <div v-if="title.length" :class="['box-header', absolute ? 'position' : '']">
      <span class="box-title" @click="titleClick">{{ title }}</span>
    </div>
    <div class="box-body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: '',
  components: {

  },
  mixins: [

  ],
  props: {
    auto: {
      type: Boolean,
      default: false
    },
    title: {
      type: [Number, String],
      default: ''
    },
    absolute: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    titleClick() {
      this.$emit('handlerClick')
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  position: relative;

  .box-header {
    height: 36px;
    line-height: 1;
    font-size: 18px;
    padding-left: 45px;
    // margin-bottom: 20px;
    background-image: url(../../assets/title-bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0 center;
    color: #2992ff;

    .box-title {
      font-weight: 500;
      font-style: italic;
      color: #FFFFFF;
      text-shadow: 0px 2px 8px rgba(5,28,55,0.42);
    }
  }

  .box-body {
    margin-top: 5px;
    padding: 5px;
    height: calc(100% - 41px);
    background: linear-gradient(270deg, #061C37 2%, #022E51 100%);
  }
}
</style>
